import { get } from 'lodash'
import { reconfigureApi } from '../../utilities/configureApi'
import { RequestCredentialsCallback } from '../types'

declare const window
interface IJavaScriptInterface {
  enableHeader(): void
  disableHeader(): void
  loadUrl(aString: string): void
}

declare const AndroidDasherClient: IJavaScriptInterface

export const enableHeader = () => {
  AndroidDasherClient.enableHeader()
}

export const disableHeader = () => {
  AndroidDasherClient.disableHeader()
}

/**
 * Loads a URL in the Android device via an app-switch to the browser
 *
 * @param {string} url
 */
export const loadUrl = (url: string) => {
  AndroidDasherClient.loadUrl(url)
}

/**
 * Expose credentials rendered via template
 * 
 * @param {Function} callback an optional function that'll recieve the credentials
 */
export const requestCredentials = (callback?: RequestCredentialsCallback) => {
  const token = get(window, 'webview.token', null)
  const dasherId = get(window, 'webview.dasherId', null)
  const uniqueLink = get(window, 'webview.uniqueLink', null)
  const deviceId = get (window, 'webview.deviceId', null)

  if (!token) {
    throw new Error('Webview Android token undefined')
  }

  reconfigureApi(token)

  if (callback) {
    callback({ token, dasherId, deviceId, uniqueLink })
  }
}
